var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7216 2.70826L18.6599 16.4583C18.7331 16.5849 18.7716 16.7286 18.7716 16.8749C18.7716 17.0212 18.7331 17.1649 18.6599 17.2916C18.5868 17.4183 18.4816 17.5235 18.3549 17.5966C18.2282 17.6697 18.0845 17.7083 17.9382 17.7083H2.06158C1.9153 17.7083 1.7716 17.6697 1.64492 17.5966C1.51824 17.5235 1.41305 17.4183 1.33991 17.2916C1.26677 17.1649 1.22827 17.0212 1.22827 16.8749C1.22827 16.7286 1.26678 16.5849 1.33992 16.4583L9.27825 2.70826C9.35139 2.58158 9.45659 2.47639 9.58327 2.40326C9.70995 2.33013 9.85364 2.29163 9.99992 2.29163C10.1462 2.29163 10.2899 2.33013 10.4166 2.40326C10.5432 2.47639 10.6484 2.58158 10.7216 2.70826ZM3.50492 16.0416H16.4949L9.99992 4.79159L3.50492 16.0416ZM9.16658 13.5416H10.8332V15.2083H9.16658V13.5416ZM9.16658 7.70826H10.8332V11.8749H9.16658V7.70826Z",
    fill: "#FF3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontIcon);
export default __webpack_public_path__ + "static/media/font-icon.e7234b496adc86526c974b24aa61a917.svg";
export { ForwardRef as ReactComponent };